const defaultEmailTemplate = {
  name: "Novo template de e-mail",
  description: "Template utilizado no envio do link de onboarding por e-mail.",
  template: `<html lang="pt-BR">

<head>
  <meta charset="UTF-8">
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700;900&amp;display=swap">
  <style type="text/css">
    h1 {
      font-size: 32px;
      margin: 20px 0 0 0;
    }

    p {
      font-size: 16px;
      margin: 26px 0;
    }

    a.button {
      text-decoration: none;
      color: white;
      background: #004af7;
      padding: 16px 20px;
      border-radius: 5px;
      font-weight: bold;
      font-size: 18px;
      transition: opacity 200ms ease;
    }

    a.button:hover {
      opacity: 0.75;
    }
  </style>
  <title></title>
</head>

<body style="font-family: Roboto; background: white; color: black; line-height: 20px;">
  <div style="width: 100%; max-width: 500px; height: auto; margin: 0 auto; text-align: center;">
    <img src="https://s3.amazonaws.com/repo.combateafraude.com/web-components-assets/images/logo_caf.png" height="50px" style="margin: 20px auto;" />
    <div style="border: 1px solid #ddd; border-radius: 12px; overflow: hidden; padding: 20px 20px 40px 20px;">
      <h1>Verifique sua identidade</h1>
      <p>Para prosseguir com o seu cadastro, precisamos que você nos informe alguns dados pessoais. Vai ser rapidinho!</p>
      <div style="margin-top: 40px;">
        <a class="button" href="{{onboardingLink}}" title=Prosseguir>Prosseguir</a>
      </div>
    </div>
    <div style="margin-top: 20px;">
      <small style="color: #999; line-height: 18px;">2022 © CAF<br>
        <a href="https://www.caf.io/" target="_blank">caf.io</a>
      </small>
    </div>
  </div>
</body>

</html>`,
};

// gif retirado <img src="https://s3.amazonaws.com/repo.combateafraude.com/web-components-assets/gifs/verify-identity.gif" width="260px">
export default defaultEmailTemplate;
